module.exports = __webpack_public_path__ + "img/client-2.eb9a57e8.png";